/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Traces_Types_Credential_AddedInputs */

const es_admin_traces_types_credential_added = /** @type {(inputs: Admin_Traces_Types_Credential_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credencial agregada`)
};

const en_admin_traces_types_credential_added = /** @type {(inputs: Admin_Traces_Types_Credential_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credential added`)
};

/**
* | output |
* | --- |
* | "Credential added" |
*
* @param {Admin_Traces_Types_Credential_AddedInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_traces_types_credential_added = /** @type {((inputs?: Admin_Traces_Types_Credential_AddedInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Traces_Types_Credential_AddedInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_traces_types_credential_added(inputs)
	return en_admin_traces_types_credential_added(inputs)
});
export { admin_traces_types_credential_added as "admin.traces.types.credential_added" }